import classNames from 'classnames';
import { forwardRef, Ref } from 'react';

import Text from 'components/common/Text';
import useStyles from 'components/common/CategoryButton/styles';

interface ICategoryButton {
  id?: string;
  icon: React.ElementType;
  className?: string;
  ariaLabel?: string;
  textContent: string;
  onClick: () => void;
  isActive?: boolean;
  tabIndex?: number;
  isDisabled?: boolean;
  isMultiLineTruncated?: boolean;
  dataTestId?: string;
}

const CategoryButton = forwardRef(({
  id, icon: Icon, className, ariaLabel, textContent, onClick, tabIndex, isActive, isDisabled, isMultiLineTruncated, dataTestId,
}: ICategoryButton, ref: Ref<HTMLButtonElement>) => {
  const classes = useStyles();

  return (
    <button
      id={id}
      data-testid={dataTestId}
      ref={ref}
      onClick={onClick}
      tabIndex={tabIndex}
      disabled={isDisabled}
      aria-label={ariaLabel}
      className={classNames(className, classes.sidebarCategory, { [classes.active]: isActive })}
    >
      <div className={classes.sidebarTextIconWrap}>
        <Icon className={classes.sidebarIcon} />
        <Text tagType="p" color="secondary" weight="semiBold" className={classNames(classes.categoryText, { [classes.categoryTextTruncatedMultiLine]: isMultiLineTruncated })}>{textContent}</Text>
      </div>
    </button>
  );
});

export default CategoryButton;
